import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';

@Injectable()
export class ContactEstimatorService extends ApiServiceBase<unknown> {
  constructor() {
    super('estimateur-contact', 'contactEstimator', 'fournierWebservice');
  }
}
